// iter_DISABLE_NEW_TENANT_SIGNUP (2026-02-28) — signup-enabled hook.
// Mirrors the `useGoogleSignInEnabled` pattern. Cached per session so
// the /signup page can decide whether to render the form or a friendly
// "closed" screen.

import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let inflight = null;

async function fetchStatus() {
  if (cached !== null) return cached;
  if (!inflight) {
    inflight = api.get("/auth/signup/enabled")
      .then((r) => { cached = r.data || { enabled: true }; return cached; })
      .catch(() => { cached = { enabled: true }; return cached; });
  }
  return inflight;
}

export function useSignupStatus() {
  const [status, setStatus] = useState(cached || { enabled: true, allowlist_only: false, message: null });
  useEffect(() => {
    let alive = true;
    fetchStatus().then((v) => { if (alive) setStatus(v); });
    return () => { alive = false; };
  }, []);
  return status;
}
